export default __webpack_public_path__ + "static/articles-lutein-howto-dceff30ca600d3b18115f086668bb613.jpg";